import React from 'react';
import { string } from 'prop-types';
import { useHistory, useLocation } from 'react-router-dom';
import { useIntl } from '../../util/reactIntl';
import css from './BackButton.css';

const BackButton = props => {
  const { className } = props;
  const intl = useIntl();
  const classes = className || css.root;

  const history = useHistory();
  const location = useLocation();

  const goBack = () => {
    history.push(location.state ? location.state.from : '/');
  };

  return (
    <div className={classes} onClick={goBack}>
      {intl.formatMessage({ id: 'BackButton.backButtonContent' })}
    </div>
  );
};

BackButton.propTypes = {
  className: string,
};

export default BackButton;
